import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  Map,
  History,
  Truck,
  Wallet,
  Link2,
  Users,
  Settings,
  LogOut,
} from 'lucide-react';
import { cn } from '@/lib/utils';
import { useAuth } from '@/store/auth';

const NAV = [
  { to: '/', label: 'Dashboard', icon: LayoutDashboard },
  { to: '/nova-rota', label: 'Nova roteirização', icon: Map },
  { to: '/historico', label: 'Histórico', icon: History },
  { to: '/frota', label: 'Frota', icon: Truck },
  { to: '/custeio', label: 'Custeio', icon: Wallet },
  { to: '/atribuicoes', label: 'Atribuições', icon: Link2 },
  { to: '/cadastros', label: 'Cadastros', icon: Users },
  { to: '/configuracoes', label: 'Configurações', icon: Settings },
] as const;

export function Sidebar() {
  const { signOut, user } = useAuth();
  const nav = useNavigate();
  return (
    <aside className="w-64 shrink-0 bg-white border-r border-ink-200 flex flex-col">
      <div className="px-5 py-5 border-b border-ink-100">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-lg bg-gradient-to-br from-brand-500 to-brand-700 grid place-items-center text-white font-bold">
            K
          </div>
          <div>
            <h1 className="text-base font-bold text-ink-900 leading-tight">Kallas</h1>
            <p className="text-xs text-ink-500 leading-tight">Roteirizador inteligente</p>
          </div>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto p-3">
        <ul className="space-y-0.5">
          {NAV.map((item) => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                end={item.to === '/'}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 px-3 py-2 rounded-lg text-sm font-medium transition',
                    isActive
                      ? 'bg-brand-50 text-brand-700'
                      : 'text-ink-700 hover:bg-ink-50 hover:text-ink-900',
                  )
                }
              >
                <item.icon className="h-4 w-4" />
                <span>{item.label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
      <div className="p-3 border-t border-ink-100">
        <div className="px-3 py-2 mb-2">
          <p className="text-xs text-ink-500 truncate">{user?.email}</p>
        </div>
        <button
          onClick={async () => {
            await signOut();
            nav('/login', { replace: true });
          }}
          className="w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-ink-700 hover:bg-ink-50"
        >
          <LogOut className="h-4 w-4" />
          Sair
        </button>
      </div>
    </aside>
  );
}
